exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-form-item{margin-bottom:20px}.el-radio-group{display:inline-flex;align-items:center;flex-wrap:wrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/modules/element.css
// module id = 651
// module chunks = 0